<template lang="pug">
  v-col
    v-card(
      v-glass=".8"
      flat)
      slot(name="header")
      v-card-text.pb-0
        v-row.justify-end.text-center(
          v-if="!routeState.isMe"
          style="margin-bottom: -22px"
          dense)
          v-col.text-right
            slot(name="call-to-action1")
        v-row.justify-center.text-center(dense)
          v-col
            slot(name="avatar")
        v-row.justify-center.text-center(dense)
          v-col.text-h6
            slot(name="name")
        v-row.align-center.justify-space-around(dense)
          v-col.shrink
            slot(name="counter1")
          v-col.text-center.shrink
            slot(name="type")
          v-col.shrink
            slot(name="counter2")
      slot(name="description")
      v-row(v-if="!routeState.isMe && $get(routeState, `user.association`) && !isUserBlocked")
        v-col.text-center
          span.mx-2
            slot(name="call-to-action3")
          span.mx-2
            slot(name="call-to-action2")
</template>

<script>
import { injectRouteState } from '@iez/core'
import isUserBlocked from '@/shared/is-user-blocked/'

export default {
  setup () {
    const routeState = injectRouteState()

    return {
      routeState,
      isUserBlocked
    }
  }
}
</script>
